<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Acknowledgments">
<h1 class="acknowledgments" id="ack">
<a id="page11">
</a><a href="#/9780310412625_epub_toc_r1#acka">
<i>Acknowledgments</i>
</a>
</h1>
<p class="nonindent">
<span class="dcap">
<em>
<b>F</b>
</em>
</span>
<span class="smallcaps">OR ALL MY HELPERS ALONG THE WAY, FROM</span> A<span class="smallcaps">DELE AT THE</span> start to Julia at the end, and for the love and support of my wife, Jackie, throughout, I give thanks and praise to the One who has supplied my every need.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310412625_epub_ack_r1.vue?86b0fb36